module.exports = __webpack_public_path__ + "media-details.ca0aca6771cdc19c9e7e51102e25690c.svg";